/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import actionTypes from './Payment-ActionTypes';

export const recordPaymentMethodType = (prevSelected) => ({
    type: actionTypes.RECORD_PAYMENT_METHOD_TYPE,
    data: {
        prevSelectedPaymentMethod: prevSelected,
    },
});

export const recordPaymentMethodTypeCompleted = () => ({
    type: actionTypes.RECORD_PAYMENT_METHOD_TYPE_COMPLETED,
});
